const walletConnect = '24f91252d3c51344469e9af3c059858b'

export { walletConnect }